/* eslint no-underscore-dangle: 0 */
/* eslint import/no-extraneous-dependencies: 0 */
/* eslint-disable react/jsx-first-prop-new-line */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { toPng } from 'html-to-image';
import { setErrorNotification } from '../../../../redux/slices/NotificationSlice';
import ModalBox from '../../../../shared/component/ModalBox';
import TemplateContentUpload from '../TemplateContentUpload';
import HtmlHeader from '../HtmlHeader';
import utils from '../templateFunctions';
import FileFormat from '../FileFormat';
import { createOrUpdateTemplate } from '../../../../redux/slices/TemplateSlice';
import PopupBox from '../ContentUploadConfirmation';

function HtmlTemplateTwentyEight({ templateData }) {
  const [data, setData] = useState([]);
  const [notification, setNotification] = useState(false);
  const [openContentUploadConfirmation, setOpenContentUploadConfirmation] = useState(false);
  const [base64, setBase64] = useState('');
  const [htmlContent, setHtmlContent] = useState('');
  const [disable, setDisable] = useState(true);
  const [modalView, setModalView] = useState({ content: '', title: '' });
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const htmlRef = useRef(null);

  const cssStyles = `
    body {
      margin: 0;
      padding: 0;
    }

    .fashionsale-card {
      position: relative;
      font-family: "Montserrat", sans-serif;
      box-sizing: border-box;
      overflow: hidden;
      width: 100%;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      height: 93.6vh;
    }
    .fashionsale-card .main-container {
      height: 100%;
      display: flex;
      align-items: center;
      flex-direction: column;
      padding: 50px;
    }
    .fashionsale-card__header {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: end;
      gap: 7px;
    }
    .fashionsale-card__header h3 {
      margin: 0;
      color: #7C7B5D;
    }
    .fashionsale-card__header img {
      width: 20px;
    }
    .fashionsale-card__content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: 100%;
      flex-wrap: wrap;
      gap: 40px;
    }
    .fashionsale-card__content__box {
      flex: 1;
      min-width: 280px;
      display: flex;
      text-align: center;
      flex-direction: column;
      gap: 25px;
      max-width: 550px;
    }
    .fashionsale-card__content__box__text {
      margin: 0;
      font-size: 40px;
      font-weight: 400;
    }
    .fashionsale-card__content__box__offer {
      margin: 0;
      font-size: 55px;
      line-height: 1.1;
      font-family: "Times New Roman", serif;
      text-transform: uppercase;
      border-top: 1px solid #999;
      border-bottom: 1px solid #999;
      padding: 20px 0;
    }
    .fashionsale-card__content__box__button {
      background-color: #7C7B5D;
      color: #fff;
      border: none;
      padding: 15px 40px;
      font-size: 18px;
      letter-spacing: 2px;
      cursor: pointer;
      text-transform: uppercase;
      transition: all 0.3s ease;
      align-self: flex-start;
      margin: auto;
    }
    .fashionsale-card__content__box__button:hover {
      background-color: #595d4f;
    }
    .fashionsale-card__content__box__description {
      margin: 0;
      font-size: 14px;
      font-style: italic;
    }
    .fashionsale-card__content__image {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: end;
      gap: 20px;
    }
    .fashionsale-card__content__image__bg1 {
      height: 350px !important;
    }
    .fashionsale-card__content__image img {
      width: 300px;
      height: 400px;
      object-fit: cover;
      border-radius: 150px 150px 0 0;
    }
    @media (max-width: 992px) {
      .fashionsale-card {
        height: 100%;
      }
      .fashionsale-card__content {
        flex-direction: column;
        text-align: center;
      }
      .fashionsale-card__content__box {
        align-items: center;
      }
      .fashionsale-card__content__box__offer {
        font-size: 40px;
      }
      .fashionsale-card__content__box__button {
        align-self: center;
      }
      .fashionsale-card__content__image {
        flex-direction: column;
      }
      .fashionsale-card__content__image__image img {
        width: 200px;
        height: 240px;
      }
    }
  `;

  const convertImage = async (url) => {
    await utils.convertSignedUrl(url)
      .then((response) => {
        setDisable(false);
        dispatch(createOrUpdateTemplate(response));
      })
      .catch((error) => {
        setDisable(false);
        dispatch(setErrorNotification(error?.response?.data));
      });
  };

  const convertBase64 = async () => {
    toPng(htmlRef?.current, { cacheBust: true })
      .then((dataUrl) => {
        setBase64(dataUrl);
        convertImage(dataUrl);
      })
      .catch((error) => {
        dispatch(setErrorNotification(error?.response?.data));
      });
  };

  const convertHtml = () => {
    if (htmlRef.current) {
      const content = htmlRef.current.outerHTML;
      const fullHtml = `
        <html>
          <head>
              <link rel="preconnect" href="https://fonts.googleapis.com" />
              <link rel="preconnect" href="https://fonts.gstatic.com" />
              <link 
              href="https://fonts.googleapis.com/css2?family=Great+Vibes&family=Urbanist:wght@100..900&display=swap" 
              rel="stylesheet" />
              <style>${cssStyles}</style>
          </head>
          <body>${content}</body>
        </html>
      `;
      setHtmlContent(fullHtml); // Set the HTML content as a string
    }
  };

  useEffect(() => {
    utils?.initializer(templateData).then((res) => (setData(res)));
    utils?.reload();
  }, [templateData]);

  /* useEffect runs convertBase64 after data is updated */
  useEffect(() => {
    if (data) {
      /* used settimeout the page was fully rendered and then called the api so wait for the response */
      setTimeout(() => {
        convertBase64();
      }, 1000);
      convertHtml();
    }
  }, [data]);

  const handleFileType = (fileType) => {
    setModalView({
      title: 'content',
      content: <TemplateContentUpload
        base64={base64}
        setNotification={setNotification}
        fileType={fileType}
        htmlContent={htmlContent}
      />,
    });
  };

  const onClickContentUpload = () => {
    setNotification(true);
    setModalView({
      title: t('fileFormat'),
      content: <FileFormat
        setNotification={setNotification}
        handleFileType={handleFileType}
        setOpenContentUploadConfirmation={setOpenContentUploadConfirmation}
        data={data}
      />,
    });
  };

  const contentDetails = data?.[0]?.template_contents?.items?.[0]?.details;
  const backgroundColor = data?.[0]?.styles?.background;
  const backgroundImage = Array.isArray(data?.[0]?.template_backgroundImage_url)
    ? data?.[0]?.template_backgroundImage_url
    : [];
  const styles = data?.[0]?.styles?.details;
  return (
    <div>
      <HtmlHeader
        htmlData={data}
        disable={disable}
        click={onClickContentUpload}
      />

      <ModalBox
        status={notification}
        closeModal={setNotification}
        modalView={modalView}
      />

      <ModalBox
        status={openContentUploadConfirmation}
        closeModal={setOpenContentUploadConfirmation}
        modalView={{
          title: 'Confirmation',
          content: <PopupBox
            setOpenContentUploadConfirmation={setOpenContentUploadConfirmation}
            setNotification={setNotification}
          />,
        }}
      />

      <div className="header-height" />

      <div
        ref={htmlRef}
        className="fashionsale-card"
        style={{ backgroundImage: `url(${backgroundImage?.[0]})` }}
      >

        <div style={{ backgroundColor: `${backgroundColor}` }} className="main-container">
          <div className="fashionsale-card__header">
            <img src={backgroundImage?.[1]} alt="" />
            <h3>{contentDetails?.[0]?.header?.toUpperCase()}</h3>
          </div>

          <div className="fashionsale-card__content">
            <div className="fashionsale-card__content__box">
              <p className="fashionsale-card__content__box__text"
                style={{
                  color: styles?.[0]?.color,
                  fontSize: styles?.[0]?.fontSize,
                  fontFamily: styles?.[0]?.fontFamily,
                }}
              >
                {contentDetails?.[0]?.item_name}
              </p>
              <h2 className="fashionsale-card__content__box__offer"
                style={{
                  color: styles?.[1]?.color,
                  fontSize: styles?.[1]?.fontSize,
                  fontFamily: styles?.[1]?.fontFamily,
                }}
              >
                {contentDetails?.[0]?.offer_percentage} offer on all products
              </h2>
              <button type="button" className="fashionsale-card__content__box__button">VISIT NOW</button>
              <p className="fashionsale-card__content__box__description"
                style={{
                  color: styles?.[2]?.color,
                  fontSize: styles?.[2]?.fontSize,
                  fontFamily: styles?.[2]?.fontFamily,
                }}
              >
                {contentDetails?.[0]?.description}
              </p>
            </div>

            <div className="fashionsale-card__content__image">
              <img src={backgroundImage?.[2]} className="fashionsale-card__content__image__bg1" alt="" />
              <img src={contentDetails?.[0].image} className="fashionsale-card__content__image__bg2" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

HtmlTemplateTwentyEight.propTypes = {
  templateData:
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      template_title: PropTypes.string.isRequired,
    }).isRequired,
  // Ensure templateData is an array of objects with specific shape
};

export default HtmlTemplateTwentyEight;
